import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPStandingsLossIconProps = StyledIconVariants & {
  onClick?: () => void;
  css?: CSS;
};

export const SMPStandingsLossIcon = (props: SMPStandingsLossIconProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <image
        width='20'
        height='20'
        xlinkHref='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0RDMDEwMCIvPgo8cGF0aCBkPSJNOC4wNjA1NSAxNVY2LjQzMzU5SDkuMDU2NjRWMTQuMDk3N0gxMi44MzU5VjE1SDguMDYwNTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K'
      />
    </SMPIcon>
  );
};
